import React from "react";

const PPPRoleSection = () => {
  const rolePoints = [
    "Local project ownership and regulatory representation",
    "Technical and commercial proposal leadership",
    "Stakeholder coordination with ministries and NCP",
    "Integration of Saudi and international expertise"
  ];

  return (
    <section 
      className="relative py-12 sm:py-16 md:py-20"
      style={{
        background: "linear-gradient(to bottom, #c99c48 30%, #8b7035 100%)",
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-8 sm:mb-12" data-aos="fade-up">
            <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              Our Role as a Private Partner
            </h2>
            <div className="w-12 sm:w-16 md:w-24 h-1 bg-white mx-auto mb-6 sm:mb-8"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start lg:items-center">
            <div data-aos="fade-right">
              <p className="text-base sm:text-lg text-gray-100 mb-6 sm:mb-8 leading-relaxed">
                Semar Holding acts as an investment and development catalyst, bridging Saudi public sector priorities with private sector capabilities.
              </p>
              <p className="text-base sm:text-lg text-gray-100 leading-relaxed mb-4 sm:mb-6">
                We provide:
              </p>
            </div>

            <div data-aos="fade-left">
              <div className="space-y-4 sm:space-y-6">
                {rolePoints.map((point, index) => (
                  <div key={index} className="flex items-start space-x-3 sm:space-x-4">
                    <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#c99c48] rounded-full flex items-center justify-center">
                      <span className="text-white font-bold text-sm sm:text-lg">✓</span>
                    </div>
                    <div className="flex-1">
                      <p className="text-sm sm:text-base md:text-lg text-gray-100 leading-relaxed">{point}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PPPRoleSection;
